// Services.jsx
import React, { useContext, useEffect, useState } from 'react';
import { ServicesContext } from '../Context/ServicesContext';
import styles from '../Services/Services.module.css';
import { BounceLoader } from 'react-spinners';
import BookingForm from '../BookingForm/BookingForm';

const Services = () => {
  const { services, isLoading: contextIsLoading } = useContext(ServicesContext);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedService, setSelectedService] = useState(null);
  const [showAddService, setShowAddService] = useState(false); // حالة عرض الفورم

  useEffect(() => {
    document.body.classList.add('services-page');
    return () => document.body.classList.remove('services-page');
  }, []);

  useEffect(() => {
    setIsLoading(contextIsLoading);
  }, [contextIsLoading]);

  const handleBookService = (service) => {
    setSelectedService(service);
  };

  const handleCloseForm = () => {
    setSelectedService(null);
    setShowAddService(false);
  };

  const handleShowAddService = () => {
    setShowAddService(true);
    setSelectedService(null); // يخفي أي مودال حجز مفتوح
  };

  if (isLoading) {
    return (
      <div className={styles.loaderContainer}>
        <BounceLoader color="#ff4d30" size={60} />
      </div>
    );
  }

  return (
    <div className={styles.servicesContainer}>
      <div className={styles.header}>
        <h1>Our <span>Services</span></h1>
        <p>Professional Car Care & Maintenance</p>
      </div>

      <div className={styles.servicesGrid}>
        {services.map((service, index) => (
          <div key={index} className={styles.serviceCard}>
            <div className={styles.imageContainer}>
              <img src={service.image} alt={service.title} />
            </div>
            <div className={styles.cardContent}>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul className={styles.features}>
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
              <div className={styles.priceRow}>
                <span>Price: ₹{service.price}</span>
                <button 
                  className={styles.bookButton}
                  onClick={() => handleBookService(service)}
                >
                  BOOK SERVICE
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

   

     

      {/* ==== مودال حجز الخدمة ==== */}
      {selectedService && (
        <BookingForm
          onClose={handleCloseForm}
          serviceTitle={selectedService.title}
          servicePrice={selectedService.price}
        />
      )}
    </div>
  );
};

export default Services;
